module.exports = __webpack_public_path__ + "static/media/img103.247013f9.jpg";